export default __webpack_public_path__ + "static/media/portfolio.81b0d2c8.jpg";